// @ts-nocheck
// Legacy, and only in the type-check program because an FSD slice imports it through
// one of the two sanctioned exceptions. Its own types were never checked and fixing
// them means guessing at API semantics — out of scope for the FSD migration. Drop this
// line when the file is migrated.
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { fetchItem, IConfig } from '@/api/configs'

export const useConfigStore = defineStore('config', () => {
  // State: Define the config object
  const config = ref<IConfig>({
    stop_words: [],
    ab_cname_domain: '0i0i0i0.com',
    asgo_domain: '',
    usage_fee_amount: 100,
    usage_fee_percent: 1,
    eur_to_usd: '1.07',
    faq_pages: [],
    adsecure_devices: {},
    adsecure_alerts: {},
    custom_alerts: {},
    adsecure_defaults: []
  })

  // Actions
  const FetchConfig = async () => {
    const response = await fetchItem()
    if (response) {
      config.value = response
    }
  }

  // Getters
  const currentConfig = computed(() => config.value)

  return {
    // State
    config,

    // Actions
    FetchConfig,

    // Getters
    currentConfig
  }
})
